import { render } from "./request-for-cert-valid.vue?vue&type=template&id=509a83a6"
import script from "./request-for-cert-valid.vue?vue&type=script&lang=js"
export * from "./request-for-cert-valid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__